import { render, staticRenderFns } from "./CanNotAccess.vue?vue&type=template&id=4f3d918d&scoped=true&lang=html&"
import script from "./CanNotAccess.vue?vue&type=script&lang=coffee&"
export * from "./CanNotAccess.vue?vue&type=script&lang=coffee&"
import style0 from "./CanNotAccess.vue?vue&type=style&index=0&id=4f3d918d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3d918d",
  null
  
)

component.options.__file = "CanNotAccess.vue"
export default component.exports